import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VOverlay,{attrs:{"color":_vm.$vuetify.theme.dark ?'grey darken-3' : 'white',"opacity":".6","absolute":""}},[_c(VProgressCircular,{attrs:{"value":40,"color":_vm.$vuetify.theme.dark ? 'white' : 'grey',"indeterminate":"","size":"60"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }